/* eslint-disable class-methods-use-this */
import { AMPLITUDE_API_KEY } from '@/constants/env';
import * as amplitude from '@amplitude/analytics-browser';
import { track } from '@amplitude/analytics-browser';
import { AmplitudeEvent, MAP_AMPLITUDE_EVENT_TO_NAME } from './constants';
import { IOrderPaymentFailedArgs, IUserIdentityArgs } from './interfaces';

const isLocalhost = window.location.hostname === 'localhost';

class Analytics {
  constructor() {
    amplitude.init(AMPLITUDE_API_KEY, {
      defaultTracking: {
        attribution: true,
        fileDownloads: false,
        formInteractions: false,
        pageViews: true,
        sessions: true,
      },
    });
  }

  public init({ userId }: IUserIdentityArgs) {
    amplitude.setUserId(userId);
  }

  public destroy() {
    amplitude.setUserId(undefined);
  }

  private registerEvent(
    event: AmplitudeEvent,
    props: Record<string, string | number | boolean | undefined> = {},
    userId?: string,
  ) {
    if (isLocalhost) {
      console.log(`Event "${event}"("${MAP_AMPLITUDE_EVENT_TO_NAME[event]}") was sent to the Amplitude for user "${userId}":: \n, ${JSON.stringify({ variables: props })}`);
      return;
    }

    track({
      event_type: MAP_AMPLITUDE_EVENT_TO_NAME[event],
      user_id: userId,
      event_properties: props,
    });
  }

  public registerOrderPaymentFailed({
    userId,
    orderId,
    purpose,
    paymentProvider,
    price,
    currency,
    tax,
    taxRate,
    createdBy,
    error,
  }: IOrderPaymentFailedArgs) {
    this.registerEvent(AmplitudeEvent.ORDER_PAYMENT_FAILED, {
      order_id: orderId,
      purpose,
      payment_integration_type: paymentProvider,
      amount: price,
      currency,
      fee_amount: tax,
      fee_percentage: taxRate,
      created_by: createdBy,
      error_text: error,
    }, userId);
  }
}

export const analytics = new Analytics();
